import { Component, ChangeDetectionStrategy , inject} from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

//Servicios
import { CompaniaService } from '@/app/services/compania.service';

//Modelos
import { Compania } from '@/app/models/Compania';

//Librerías externas
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { ThisReceiver } from '@angular/compiler';

@Component({
    selector: 'app-insertar-compania',
    templateUrl: './insertar-compania.component.html',
    styleUrls: ['./insertar-compania.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InsertarCompaniaComponent {
  private spinner = inject(NgxSpinnerService);

  //Ng-model
  CompaniaRQ = {
    clave:null,
    descripcion: null
  };

  //Bandera global para cerrar el modal
  hasFinished: boolean = false;

  constructor
  (
    private CompaniaService: CompaniaService,
    private toastr: ToastrService, 
    private router: Router,
    public dialogRef: MatDialogRef<InsertarCompaniaComponent>,

  )
  {

  }
    //Submit y crear Compania
    formSubmit(form: NgForm){
      if(form.valid){
        Swal.fire({
          title: 'Confirmar',
          text: "¿Deseas crear una nueva compañia?",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#1c869e ',
          cancelButtonColor:  '#999999',
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Regresar',
          allowOutsideClick: true,
          reverseButtons: true
        }).then((result) => { 
          if(result.value){
            this.insertarCompania();
          }
        });
      }
    }

    insertarCompania(){
      this.spinner.show();
      this.CompaniaService.insertarCompania(this.CompaniaRQ).subscribe({
      next: (data: any)=>{
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Compañia registrada correctamente.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();

        });

      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ExceptionMessage } = err.error;
            this.toastr.error(ExceptionMessage ? ExceptionMessage : 'Se ha producido un error al obtener lista de tipos de usuario.', 'Error');
          }
        }
        console.log(err);
        }
      });
  }
  onClose(){
    if(!this.hasFinished){
      Swal.fire({
        title: 'Alerta',
        text: "No se ha registrado la compañia. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      this.dialogRef.close({updateList: true});
    }

  }

}

